'use strict';

define('composer/video', ['quill'], (Quill) => {
	const BlockEmbed = Quill.import('blots/block/embed');

	class Video extends BlockEmbed {
		static create(params) {
			const p = params || {};
			const node = super.create();
			const video = document.createElement('video');
			const div = document.createElement('div');
			node.dataset.id = p.id;
			node.id = 'ql-media__' + p.id;
			node.className = 'ql-media';
			node.appendChild(div);
			div.appendChild(video);
			video.id = 'ql-video__' + p.id;
			video.className = `ql-video`;
			video.setAttribute('uploadid', p.id);
			// video.setAttribute('controls', 'controls');
			// video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
			// video.setAttribute('disablepictureinpicture', true);
			// video.setAttribute('allowfullscreen', true);
			if (p.src) {
				video.setAttribute('src', p.src);
			}
			if (p.poster) {
				video.setAttribute('poster', p.poster);
			}
			if (p.size) {
				video.setAttribute('data-width', p.size.width);
				video.setAttribute('data-height', p.size.height);
			}
			$(video).videoPlayer({
				isUpload: true,
			});
			return node;
		}

		static value(domNode) {
			const video = domNode.querySelector('video');

			if (video) {
				return {
					id: domNode.dataset.id,
					src: video.getAttribute('src') || '',
					poster: video.getAttribute('poster') || '',
					width: video.getAttribute('data-width') || '',
					height: video.getAttribute('data-height') || '',
				};
			}

			return {};
		}
	}

	Video.blotName = 'Video';
	Video.tagName = 'div';

	return Video;
});
